export const metricFieldMap = {
  total: {
    rank: "avg_rank",
    outstanding: "outstanding_payment",
    month: "month_payment",
    total: "total_payment"
  },
  deterministic: {
    rank: "avg_rank_det",
    outstanding: "outstanding_payment_det",
    month: "month_payment_det",
    total: "total_payment_det"
  },
  probabilistic: {
    rank: "avg_rank_prob",
    outstanding: "outstanding_payment_prob",
    month: "month_payment_prob",
    total: "total_payment_prob"
  }
};

export const metricOptions = [
  { value: 'deterministic', label: 'Deterministic' },
  { value: 'probabilistic', label: 'Probabilistic' },
  { value: 'total', label: 'Total' },
];